/** 联合订单分包业务文案 — 中文 */
export default {
  combinedOrder: {
    nav: {
      confirmTitle: '确认订单',
      detailTitle: '订单详情',
      combinedOrderTitle: '{ticketType}酒店 组合订单',
      unionDetailTitle: '联合订单详情',
    },
    banner: {
      couponTitle: '本单预计享0门槛{amount}元优惠券',
      couponDesc: '订单完成后可在我的优惠券中查看',
      installmentTitleIndex: '可享{period}期免息',
      installmentTitleDetail: '最高{period}期免息',
      installmentDesc: '组合下单享分期优惠',
    },
    orderType: {
      tag: '{ticketType}+酒店 组合订单',
      plane: '机票',
      internationalPlane: '国际机票',
      train: '火车票',
      fallback: '订单',
    },
    ticket: {
      infoTitle: '{ticketType}信息',
      detail: '详情',
      outbound: '去程',
      return: '返程',
      refundDetail: '退改详情',
      refundRules: '退改说明',
      stopover: '经停 >',
      pricePerPerson: '￥{amount}/人',
      route: '行程',
      date: '日期',
      fee: '{ticketType}费用',
      routeFallback: '行程信息',
      flightDetailTitle: '航班详情',
      totalDuration: '总时长 {duration}',
      stopoverMinutes: '经停:{time}',
      ticketPriceTimes: '票价 × {count}人',
      priceTimesPerson: '￥{price}×{count}人',
      priceTimesRoom: '￥{price} × {count}间',
      priceTimesNightsRooms: '￥{price} × {nights}晚 × {count}间',
      trainDetailTitle: '火车票详情',
      trainNoInfo: '车次信息',
      departureDate: '出发日期',
      seatInfo: '座位信息',
      seatType: '坐席类型',
      ticketPrice: '票价',
      selectedSeats: '已选座位',
      berthSelection: '铺位选择',
      seatPreference: '座位偏好',
      cardTagPlane: '机票',
      cardTagTrain: '火车票',
      flightAmount: '机票金额',
      serviceFee: '服务费',
    },
    passenger: {
      infoTitleTrain: '乘客信息',
      infoTitlePlane: '乘机人信息',
      sectionTitleTrain: '乘客',
      sectionTitlePlane: '乘机人',
      sectionSuffix: '信息',
      selectAll: '全选',
      deselectAll: '取消全选',
      noChildSupport: '当前航班不支持儿童乘客',
      addTrain: '新增乘客',
      addPlane: '新增乘机人',
      typeAdult: '成人',
      typeChild: '儿童',
      typeStudent: '学生',
      typeDisabledMilitary: '残疾军人',
      typeInfant: '婴儿',
      trainTicketAdult: '成人票',
      trainTicketChild: '儿童票',
      trainTicketStudent: '学生票',
      trainTicketDisabledMilitary: '残疾军人票',
      idCard: '身份证',
      passport: '护照',
      militaryId: '军官证',
      hkmPass: '港澳通行证',
      taiwanCompatriot: '台胞证',
      homeReturnPermit: '回乡证',
      idNumber: '证件号',
      selectPassenger: '请选择乘客',
      selectPlanePassenger: '请选择乘机人',
      childAloneTrain: '儿童不能单独乘车，至少需要一位成人陪同',
      childAlonePlane: '儿童不能单独乘机，至少需要一位成人陪同',
      hotelContactFromFirst:
        '酒店联系信息默认取已选乘机人（优先成人）的姓名及手机号，可在下方酒店订房信息中修改',
    },
    insurance: {
      serviceTitle: '保险服务',
      accidentTitle: '航空意外险',
      delayTitle: '航班延误险',
      noInvoice: '无发票',
      noCoverage: '无保障',
      insuredLabel: '投保人',
      selectInsured: '请选择投保人',
      viewEdit: '查看/修改',
      adultOnlyTip: '投保人需年满18周岁',
      feeWithCount: '保险费用（{count}人）',
      feeTimesCount: '保险费用x{count}',
      fallbackName: '航空意外险',
      selectInsuredTitle: '选择投保人',
      addInsured: '新增投保人',
      purchasedServices: '已购/赠送服务',
      label: '保险',
      statusPending: '待处理',
      statusProcessing: '投保中',
      statusSuccess: '投保成功',
      statusFailed: '投保失败',
      statusRefundSuccess: '退保成功',
      statusRefundFailed: '退保失败',
      statusRefunding: '退保中',
      statusCancelled: '取消',
      statusRescheduleSuccess: '改签投保成功',
      statusRescheduleFailed: '改签投保失败',
      statusUnknown: '未知状态',
    },
    seat: {
      onlineSelection: '在线选座',
      legendTitle: '座位图例',
      available: '可选',
      selected: '已选',
      window: '窗',
      aisle: '过道',
      upperBerth: '上铺',
      upperBerthDesc: '价格较低，空间较小',
      middleBerth: '中铺',
      middleBerthDesc: '适中价格，便于上下',
      lowerBerth: '下铺',
      lowerBerthDesc: '价格较高，方便舒适',
      windowSide: '靠窗',
      windowSideDesc: '欣赏沿途风景',
      aisleSide: '靠过道',
      aisleSideDesc: '方便进出走动',
      selectedSeatsLabel: '已选座位：',
      preferenceLabel: '座位偏好：',
      clear: '清空',
      sectionTitle: '选座信息',
      detailSleeperTitle: '卧铺选座',
      detailPreferenceTitle: '座位偏好',
      preferenceNotice: '此为您创建订单时的选座偏好，实际出票座位可能有所不同',
      berthSelectedSummary: '已选择 {selected} 个铺位 / 共需 {total} 个',
      preferenceSelectedSummary: '已选择 {selected} 个座位偏好 / 共需 {total} 个',
      selectedSeatsHeader: '已选座位 ({selected}/{total})',
      businessSeatTitle: '商务座选座',
      firstSeatTitle: '一等座选座',
      secondSeatTitle: '二等座选座',
    },
    trainOptions: {
      title: '购票选项',
      acceptNoSeat: '接受无座',
      acceptNoSeatDesc: '如该坐席售完，是否购买无座票',
      yes: '是',
      no: '否',
    },
    hotel: {
      infoTitle: '酒店信息',
      roomDetail: '房型详情',
      reservationTitle: '订房信息',
      roomCount: '房间数',
      roomCountValue: '{count}间',
      roomNightsSummary: '{rooms}间{nights}晚',
      maxGuests: '最多{count}人',
      roomFeeRoomsNights: '房费 {rooms}间 × {nights}晚',
      arriveAfter: '{time} 后',
      arriveBefore: '{time} 前',
      guestName: '住客姓名',
      guestNamePlaceholder: '第{index}间入住人姓名',
      nameGuideTitle: '姓名填写说明：',
      lastNameGuide: '姓：用英文或中文拼音，如 li',
      firstNameGuide: '名：用英文或中文拼音，如 hao',
      roomGuestTitle: '第{index}间房入住人信息',
      lastName: '姓',
      firstName: '名',
      lastNamePlaceholder: '如：li',
      firstNamePlaceholder: '如：hao',
      contactPhone: '联系手机',
      contactPhonePlaceholder: '请输入联系手机',
      fee: '酒店费用',
      refundTip: '温馨提示：联合订单若酒店订房成功后申请退订酒店，需按3%比例收取额外的平台手续费',
      cardTag: '酒店',
      contactHotel: '联系酒店',
      facilitiesPolicy: '设施·政策',
      map: '地图',
      checkIn: '入住',
      checkOut: '离店',
      nights: '{count}晚',
      roomInfoTitle: '房型信息',
      guestLabel: '入住人',
      remark: '备注',
      roomFallback: '房间',
      roomFeeNights: '房费（{nights}晚）',
      dateMonthDay: '{month}月{day}日',
      nonRefundable: '不可退订',
      afterBookingSuccess: '预订成功后',
      freeCancel: '免费',
      floorSuffix: '层',
    },
    price: {
      detailTitle: '价格明细',
      detailShort: '明细',
      viewDetail: '查看明细',
      adultTicketTimes: '成人票价 x{count}',
      childTicketTimes: '儿童票价 x{count}',
      serviceFeeTimes: '服务费x{count}',
      subtotal: '{ticketType}小计',
      total: '合计',
      amountDetailTitle: '金额明细',
      planeFeeTitle: '机票费用',
      trainFeeTitle: '火车票费用',
      adult: '成人',
      child: '儿童',
      planeTicket: '机票',
      airportFee: '机建',
      fuelTax: '燃油',
      roomFee: '房费',
      payableAmount: '应付金额',
      paid: '实付',
      orderDetailTitle: '订单明细',
      mainCouponLabel: '联合订单优惠券',
      insuranceFeeTimesPerson: '保险费× {count} 人',
    },
    coupon: {
      title: '优惠券',
      discountFallback: '优惠券抵扣',
      availableCount: '{count}张可用',
      noneAvailable: '暂无可用优惠券',
      selectTitle: '选择优惠券',
      doNotUse: '不使用优惠券',
      validUntil: '有效期至：{time}',
      discountUnit: '折',
      subLabel: '┗ 优惠券',
      noThreshold: '无门槛',
      fullReduction: '满{minAmount}减{amount}',
      instantReduction: '立减{amount}元',
      fullDiscount: '满{minAmount}享{discount}折',
      percentDiscount: '{discount}折优惠',
      fallback: '优惠券',
      selectedToast: '已选择优惠券，优惠￥{amount}',
    },
    payment: {
      title: '支付方式',
      combinedTitle: '组合支付',
      combinedDesc: '{ticketType}+酒店一起支付，享受分期优惠',
      ticketOnlyTitle: '仅支付{ticketType}',
      ticketOnlyDesc: '单独支付{ticketType}，酒店稍后预订',
      submitOrder: '提交订单',
      payNow: '立即支付',
      cancelOrder: '取消订单',
    },
    installment: {
      agreePrefix: '我已阅读并同意',
      noticeLink: '《分期服务须知》',
      noticeTitle: '分期服务须知',
      agreeCheckbox: '我已阅读并同意《分期服务须知》',
      intro: '为保障您的权益，请您仔细阅读并充分理解以下内容。当您使用机票/火车票+酒店合并支付功能并选择信用卡分期时，即视为您已阅读、理解并同意本须知全部条款。',
      section1Title: '1. 分期服务说明',
      section1Item1: '1.1 本分期服务仅限于用户在同一订单中同时购买"机票+酒店"或"火车票+酒店"，且通过合并支付通道完成支付时方可享有。',
      section1Item2: '1.2 符合上述条件的订单，在支付环节选择信用卡分3期，可享受0手续费（即免息分期），相关分期平台承担。',
      section1Item3: '1.3 单独支付机票、单独支付火车票或单独支付酒店，均不享受本分期权益。',
      section2Title: '2. 权益生效与变更',
      section2Item1: '2.1 分期免息资格以订单实际支付成功为准。若支付失败、订单取消或发生退款，分期权益自动失效。',
      section2Item2: '2.2 若合并支付后发生部分退款（如仅退还酒店部分），剩余交通票订单将不再享受免息分期资格，分期手续费可能由用户承担，具体以银行账单为准。',
      section3Title: '3. 支付提示',
      section3Item1: '3.1 分期服务由发卡银行提供，实际分期额度、到账时间、还款规则等以银行规定为准。',
      section3Item2: '3.2 若因银行额度不足、卡片状态异常等原因导致分期失败，订单将按全额支付处理，不再享受免息分期。',
      section4Title: '4. 其他',
      section4Item1: '4.1 本公司有权根据运营需要调整分期活动规则，调整后的规则将在页面公示，不再另行单独通知。',
      section4Item2: '4.2 如有疑问，可咨询客服或联系客服电话4007659936',
      effectiveDate: '生效日期：2026年2月',
      confirm: '确定',
      cancel: '取消',
      agreeRequired: '请先阅读并同意分期服务须知',
      periodConfirmTitle: '提示',
      periodConfirmMsg: '您选择的酒店不可分3期支付，请重新选择或继续',
      reselect: '重新选择',
      continue: '继续',
    },
    popup: {
      collapse: '收起',
      loading: '加载中...',
      stopStationsTitle: '经停站信息',
      loadingStopStations: '加载经停站信息...',
      stopNotice: '具体以列车实际运行情况为准，请及时关注车站广播',
      stationName: '站名',
      arrive: '到达',
      depart: '发车',
      stopover: '停留',
      stopMinutes: '停{minutes}分',
      actionCancel: '取消',
    },
    planeRefund: {
      title: '退改签、行李额',
      refundRulesTitle: '退票收费规则',
      airlinePolicyOriginal: '航空公司政策原文',
      adult: '成人',
      child: '儿童',
      adultChild: '成人、儿童',
      currentPeriod: '当前时段',
      perPerson: '/人',
      timeColumn: '时间',
      summaryColumn: '一言以蔽之',
      fuelOnlyRefund: '只退机建和燃油',
      changeRulesTitle: '改期手续费规则',
      transferRulesTitle: '签转其他航空公司条件',
      luggageRulesTitle: '免费行李规定',
      noRefundInfo: '暂无退改签信息',
      fetchFailed: '获取退改签信息失败',
    },
    refundRules: {
      trainTitle: '退票/改签说明',
      refundFeeTitle: '退票手续费标准',
      railwayFeeLabel: '铁路局退票手续费：',
      refundRule1: '1）开车前8天(含)以上：免费退票',
      refundRule2: '2）开车前48小时以上：收取票价5%的退票费',
      refundRule3: '3）开车前24-48小时：收取票价10%的退票费',
      refundRule4: '4）开车前不足24小时：收取票价20%的退票费',
      refundRule5: '5）开车前2小时后线上停止退票',
      noteLabel: '说明：',
      note1: '1）退票手续费由铁路局收取；',
      note2: '2）手续费不足2元按照2元收取；',
      note3: '3）距离开车7天及以内的车票，改签至8天及以上后退票收取5%的手续费；',
      note4: '4）下单成功手续费不予返还；',
      note5: '5）平台额外增加17元退票手续费(每人，不包含12306购票方式)；',
      note6: '6）退票约7个工作日内到账。',
      changeRulesTitle: '改签规则',
      platformChangeFee: '特别说明：改签时平台额外增加17元退票改签费(每人，不包含12306购票方式)',
      springFestivalNotice: '改签或变更到站后的车票乘车日期在春运期间的，再退票时按票面价格20%核收退票费。',
      changeBasicTitle: '1. 改签基本规则',
      changeBasicIntro: '改签是旅客变更乘车日期、时间、车次、席位、席别和到站时需办理的签证手续。',
      changeOnceOnly: '旅客可办理一次改签',
      changeBasicSuffix: '，在铁路运输企业有运输能力的前提下，按下列规定办理：',
      changeRule1: '1）开车前48小时以上，可免费改签预售期内的列车。',
      changeRule2: '2）开车前不足48小时，可免费改签车票载明的乘车日期以前的列车。',
      changeRule3: '3）开车前不足48小时，可改签车票载明的乘车日期之后预售期内列车，核收改签费。',
      changeRule4: '4）开车后，在当日24时之前，可免费改签当日其他列车。',
      changeRule5: '5）开车后，在当日24时之前，可改签车票载明的乘车日期之后预售期内列车，核收改签费。',
      changeRule6: '6）办理变更到站的改签时，应在开车前48小时以上，原车票已托运行李的，还应办理行李变更或取消业务。',
      changeStationNotice: '办理变更到站的改签时，应在开车前48小时以上。',
      reimbursementTitle: '2. 报销凭证相关规定',
      reimbursementContent: '已打印报销凭证的和使用现金支付方式购买的车票，仅可在车站售票窗口办理改签，',
      returnVoucher: '并须交回报销凭证',
      priceDiffTitle: '3. 票价差额处理',
      priceDiffContent: '旅客办理改签时，改签后的车票票价高于原票价时，核收票价差额；改签后的车票票价低于原票价时，退还票价差额，核收票价差额的退票费。',
      afterDepartureTitle: '4. 开车后改签限制',
      noRefundAfterChange: '开车后改签的车票，不办理退票。',
      changeRefundDiffTitle: '5. 改签退差费用标准',
      changeRefundDiffIntro: '改签退差时，票价差额退票费核收标准：',
      changeRefundDiff1: '1）距票面乘车站开车前8天以上的不收退票费',
      changeRefundDiff2: '2）开车前48小时以上、不足8天的，按票面价格5%计',
      changeRefundDiff3: '3）开车前24小时以上、不足48小时的，按票面价格10%计',
      changeRefundDiff4: '4）开车前不足24小时的，按票面价格20%计',
      specialCasesTitle: '特殊情况',
      specialCase1: '1）因病、学生证过期等特殊原因，按相关规定办理',
      specialCase2: '2）列车停运、晚点2小时以上等，可免费退票',
      specialCase3: '3）退款到账时间：7个工作日内（以银行处理时间为准）',
      specialCase4: '4）具体规定以铁路部门最新公告为准',
      tipsTitle: '温馨提示',
      tipsContent: '本信息根据中国铁路12306官方规定整理，如有变更请以官方最新公告为准。',
    },
    status: {
      detailFallback: '订单详情',
      countdownRemaining: '剩余{time}',
      countdownExpired: '已超时',
      orderNo: '订单号：{orderNo}',
      orderTime: '下单时间：{time}',
      copy: '复制',
      paySoon: '请尽快完成支付',
      paidSuccess: '订单已支付成功',
      cancelled: '订单已取消',
      completed: '订单已完成',
      today: '今天',
      tomorrow: '明天',
      dayAfterTomorrow: '后天',
      sunday: '周日',
      monday: '周一',
      tuesday: '周二',
      wednesday: '周三',
      thursday: '周四',
      friday: '周五',
      saturday: '周六',
      empty: '暂无订单信息',
    },
    dialog: {
      tipTitle: '提示',
      flightNotExist: '您选购的航班已不存在，请重新选购航班',
      backReselect: '返回重选',
      priceChangeTitle: '价格变动提醒',
      trainPriceChanged: '当前火车票价格已更新为{amount}元/人，是否继续支付？',
      planePriceChanged: '当前机票价格已更新为成人票{adultPrice}元/人，儿童票{childPrice}元/人，是否继续支付？',
      continuePay: '继续支付',
      cancelOrderTitle: '取消订单',
      cancelOrderMsg: '确定要取消该联合订单吗？取消后将无法恢复。',
    },
    toast: {
      maxSeats: '最多只能选择{count}个座位',
      maxBerths: '最多只能选择{count}个铺位',
      stopStationFailed: '获取经停站信息失败',
      queryStopStationFailed: '查询经停站信息失败',
      travelerListFailed: '获取常旅列表失败',
      selectCouponFailed: '选择优惠券失败',
      fillGuestName: '请填写入住人姓名',
      fillContactPhone: '请填写联系电话',
      phoneNoMask: '联系电话中不能带星号，请完善联系人信息',
      submitCombinedFailed: '提交组合订单失败',
      submitFailed: '提交订单失败',
      orderExpired: '订单数据已过期，请重新选择',
      hotelInfoFailed: '酒店信息获取失败',
      orderNoEmpty: '订单号不能为空',
      fetchDetailFailed: '获取订单详情失败',
      cancelSuccess: '订单取消成功',
      cancelFailed: '取消订单失败',
      addressCopied: '已复制地址',
      missingOrderNo: '缺少订单号参数',
    },
    common: {
      perPerson: '/人',
      dash: '--',
      unknownOrderType: '未知订单类型',
    },
  },
}
